import HubSpotCTA from './HubSpotCTA'
import ABN from './ABN'
import { planPrice } from 'common/utils/planPrice'
import { PlanSlug } from 'common/planSlugs'
import { Format } from 'common/utils'

const BlogPostProductCTA = () => {
  const ctaData = [
    {
      ctaId: '191841523246',
      href: 'https://cta-service-cms2.hubspot.com/web-interactives/public/v1/track/redirect?encryptedPayload=AVxigLKcHrpCv7EO771rd6jclpsEpi0G8O4DPIR63wqxGt%2BB706i78BNjiUWXW1HAsn2WYGro6CVTUvYFqa6qk3pgpXPToYeEvF0huPutk%2BPQdi1u5Bv222t0Qg156QgxsPY%2FaadoFRYIX%2F6YS3FZ6Pl8wtBVInvzRfZ9HoerxnHh5HvIOZKpHYCNICg%2Fr6vpcnnntPShtxlPd%2FtLIkVUcFC&webInteractiveContentId=191841523246&portalId=48114419',
      imgSrc:
        'https://no-cache.hubspot.com/cta/default/48114419/interactive-191841523246.png',
    },
    {
      ctaId: '191843937574',
      href: 'https://cta-service-cms2.hubspot.com/web-interactives/public/v1/track/redirect?encryptedPayload=AVxigLKsdT2qfkzTJu1kPzPjZ6zZDy0TotzAGUl73nx2fDWZHKO8cc9EWz%2BliGiY684Xd2Bj0qeGXt%2Bp0xNWtaQ%2BkMKh1MkfR4diaiNnWRfWwfkuHXUW367a3f1gAMbslPrFMlFwnk5tS2KM3oBpk%2BG2bAWy8mZ51YmEAM2YyTr76YMD5pkllnBhaiqTwbr5e4Kwv%2FqKss4d70oeNYtaF%2FSf&webInteractiveContentId=191843937574&portalId=48114419',
      imgSrc:
        'https://no-cache.hubspot.com/cta/default/48114419/interactive-191843937574.png',
    },
    {
      ctaId: '191843937586',
      href: 'https://cta-service-cms2.hubspot.com/web-interactives/public/v1/track/redirect?encryptedPayload=AVxigLL8LM3d%2BxZykcJFmsxhPjXY16SEXfHnjkjtuzc1eYp%2FFFHFlahMXzHmQN76g41ygq5BhIhkLpa%2BbsKv%2Bo0aWA6CRfqPHhr3j1zEugaxXhr2Oe7lVBPAMFTyRKq7uc2pd%2BlK4uStA0JW1Tpj4sjikjM2e9oZWmykrpsF9exWQ9FmQdCz7eT0XT8MrHKQdls%2FLSgQU3yB6Umf%2Fh%2FD6L4x&webInteractiveContentId=191843937586&portalId=48114419',
      imgSrc:
        'https://no-cache.hubspot.com/cta/default/48114419/interactive-191843937586.png',
    },
  ]

  return (
    <ABN className='px-md-20' id='blogpost_product_cta'>
      {ctaData.map(({ ctaId, href, imgSrc }) => (
        <HubSpotCTA key={ctaId} ctaId={ctaId}>
          <a href={href} target='_blank' rel='noopener noreferrer'>
            <img
              src={imgSrc}
              alt={`Find the right virtual office address for your business with plans starting from ${Format.money(
                planPrice.dailyOnYearlyPlan(PlanSlug.SCAN_LITE),
              )} a day`}
              loading='lazy'
              style={{ height: '100%', objectFit: 'fill', width: '100%' }}
              onError={(e) => (e.currentTarget.style.display = 'none')}
            />
          </a>
        </HubSpotCTA>
      ))}
    </ABN>
  )
}

export default BlogPostProductCTA
